/**
 * Dev/admin gating for the LEVEL EDITOR. The editor is a creator tool, never a player-facing feature —
 * it is OFF by default so the live game is untouched. It opens when:
 *   • the build is a DEV build (local development), OR
 *   • the URL carries `?editor=1` (which we then PERSIST), OR
 *   • a previous `?editor=1` visit set the `dd:editor` localStorage flag.
 *
 * This mirrors the existing DEV-gated `__duck*` observability hooks: nothing here ships an editor entry
 * point to an ordinary player.
 */
const FLAG_KEY = 'dd:editor';

export function isEditorEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env?.DEV) return true;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('editor') === '1') {
      window.localStorage.setItem(FLAG_KEY, '1'); // persist so a later /editor visit (no query) still opens
      return true;
    }
    return window.localStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
}
